<template>
  <div class="card">
    <div v-if="readyState.dienstleister" class="card-body" style="min-height:200px">
      <div class="default-table-head">
        <div class="v-super" @click="debug">Dienstleister</div>
        <div class="icon-clickable-right">
          <feather id="addDienstleisterButton" type="plus" v-b-modal.addDl></feather>
          <b-tooltip target="addDienstleisterButton" triggers="hover" placement="left">Dienstleister hinzufügen</b-tooltip>
        </div>
      </div>
      <div style="position:relative;">
        <Loader v-if="updating" />
      </div>
      <transition :name="anim.fadeIn.name" :enter-active-class="anim.fadeIn.enter" :leave-active-class="anim.fadeIn.leave">
        <div class="default-table" v-if="!updating">
          <div class="default-table-legend" v-if="selected.length > 0">
            <div>Name</div>
            <div>Branchen</div>
            <div>Aktionen</div>
          </div>
          <div class="default-table-row" v-for="dl in selected" :key="dl.id">
            <div>{{ dl.name }}</div>
            <div>{{ dl.extended.branchenString }}</div>
            <div>
              <router-link :to="'/admin/dashboard/dienstleister/' + dl.id">
                <feather type="edit-2" class="small-icon tight-icon infra-blue pointer"></feather>
              </router-link>
              <feather type="trash" class="small-icon tight-icon infra-blue pointer" @click="unassignDienstleister(dl.id)"></feather>
            </div>
          </div>
          <div v-if="!selected.length" class="text-center">
            Keine Dienstleister definiert
          </div>
        </div>
      </transition>
    </div>
    <b-modal size="xl" id="addDl" @ok="updateDienstleister">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card-body" v-if="items">
              <b-row>
                <b-col md="12" class="list_mode">
                  <b-input-group class="datatable-btn">
                    <b-form-input v-model="filter" placeholder="Suchen"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Zurücksetzen</b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-group label-cols="2" label="Pro Seite" class="datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                  <b-form-group label="Auswahlmodus:" label-cols="4" class="datatable-select mt-3">
                    <b-form-select v-model="selectMode" :options="modes" class="mb-3"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue">
                <b-table
                  :select-mode="selectMode"
                  show-empty
                  stacked="md"
                  :items="items"
                  :fields="tablefields"
                  :filter="filter"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(auswahl)="selection">
                    <input type="checkbox" name="selectedDienstleister" :checked="isAssigned(selection)" @click="checkSelection(selection)" />
                  </template>
                  <template slot="empty">Keine Dienstleister gefunden.</template>
                </b-table>
              </div>

              <b-col md="6" class="my-1" v-if="totalRows > perPage">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
              </b-col>
            </div>
          </div>
        </div>
      </div>
      <template slot="modal-ok">
        Speichern
      </template>
      <template slot="modal-cancel">
        <div>Abbrechen</div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/LoaderRelative.vue";

export default {
  name: "AdminDienstleister",
  props: ["bauprojekt_id"],
  components: {
    Loader: Loader,
  },
  data() {
    return {
      has_bp: false,
      modes: ["multi", "single", "range"],
      tablefields: [
        { key: "auswahl", label: "Auswahl", sortable: false },
        { key: "name", label: "Name", sortable: true },
        { key: "extended.branchenString", label: "Branche", sortable: true },
        { key: "email", label: "email", sortable: true },
        { key: "telefon", label: "phone", sortable: true },
      ],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      selectMode: "single",
      items: false,
      selected: [],
      bauprojekt_data: false,
      bauprojekt_dienstleister: false,
      updating: false,
    };
  },
  async created() {
    const filterDl = {
      bauprojekt_id: this.$route.params.bauprojekt_id,
    };
    try {
      this.updating = true;
      await this.$store.dispatch("app/apiGetDienstleister");
      await this.$store.dispatch("app/getRelationItems", { collection: "bauprojekt_dienstleister", filter: filterDl });
      await this.$store.dispatch("app/updateSingle", { resource: "bauprojekt", id: this.$route.params.bauprojekt_id });
      this.updating = false;
    } catch (error) {
      console.log(error);
    }
    this.items = this.dienstleister;
    this.setBpData();

    if (!this.bauprojekt_data.extended.dienstleister) return;

    this.bauprojekt_data.extended.dienstleister.forEach((dl) => {
      this.selected.push(dl);
    });
  },
  computed: {
    ...mapGetters({
      readyState: "app/readyState",
      anim: "app/animations",
      dienstleister: "app/dienstleister",
      bauprojekte: "app/bauprojekte",
    }),
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    isAssigned(selection) {
      return this.selected.indexOf(selection.item) > -1 ? true : false;
    },
    checkSelection(selection) {
      const isSelected = this.selected.indexOf(selection.item);
      if (isSelected > -1) this.selected.splice(isSelected, 1);
      if (isSelected == -1) this.selected.push(selection.item);
    },
    clone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    setBpData() {
      const bauprojekt = this.bauprojekte.find((bp) => bp.id == this.$route.params.bauprojekt_id);
      this.bauprojekt_data = bauprojekt;
    },
    unassignDienstleister(id) {
      const targetIndex = this.selected.findIndex((item) => {
        return item.id == id;
      });
      this.selected.splice(targetIndex, 1);
      this.updateDienstleister();
    },
    async updateDienstleister() {
      try {
        const selected_dienstleister = this.selected.map((selected) => {
          return {
            bauprojekt_id: this.bauprojekt_id,
            dienstleister_id: selected.id,
          };
        });
        const payload = {
          collection: "bauprojekt_dienstleister",
          items: selected_dienstleister,
          bp: this.bauprojekt_id,
        };

        await this.$store.dispatch("app/syncDienstleisterBauprojekt", payload);
        await this.$store.dispatch("app/updateSingle", {
          resource: "bauprojekt",
          id: this.bauprojekt_id,
        });
        this.setBpData();
      } catch (error) {
        console.log(error);
      }
    },
    debug() {
      console.log(this.selected);
    },
  },
};
</script>

<style></style>
